// extracted by mini-css-extract-plugin
module.exports = {"link":"_BackToSearch_link__3I5mq","text":"_BackToSearch_text__3pXUB","icon":"_BackToSearch_icon__3VaI4"};